import { AssessmentQuestion } from "../questionTypes";

// Owner Readiness Questions - To be updated
export const ownerReadinessQuestions: AssessmentQuestion[] = [
  // Questions will be added here
];
